import React from 'react';
import Header from './components/Header';
import Body from './components/Body';
import Contact from './components/Contact';



function App() {
  return(
   <div>
    <Header />
    <Body />
    <Contact />
    
   </div>
    

  );
}

export default App;
